import { useState, useEffect } from "react";
import "./styles/payinfo.scss";
import Address from "./component/address";
import axios from "axios";
import { backend } from '../../components/apipath';
import { useAuth } from "../../pages/login/AuthProvider";
import { usePayment } from "../../components/PaymentContext";
import { useNavigate } from "react-router-dom";

function Payinfo() {
    const { step, setStep } = usePayment();
    const [showCourses , setShowCourses] = useState(false);
    const { mem_id } = useAuth();
    const { authorized } = useAuth()
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        fname: "",
        lname: "",
        email: "",
        phone: "",
        idIdentity: "",
        school: "",
        address: "",
        tax_num: "",
        company: "",
        status: "",
        deliver: [],
        course: [],
        book: [],
        info_way: [],
    });

    const [errors, setErrors] = useState({
        name: "",
        fname:"",
        lname:"",
        email: "",
        phone: "",
        idIdentity: "",
        school: "",
        address: "",
        status:"",
        deliver: "",
        course: "", 
        book: "",
        info_way: "",
    });
    
    useEffect(() => {
        const selectedPlan = localStorage.getItem("selectedPlan");
    
        if (!authorized) {
            navigate("/member/memberlogin");
        } else if (step < 1 || !selectedPlan) {
            navigate("/registration/plan");
        }
    }, [authorized, step, navigate]);
    // if (!productId) {
    //     navigate("/registration/plan");
    // }
    // useEffect(() => {
    //     const selectedPlan = localStorage.getItem("selectedPlan");

    //     if (!authorized) {
    //         navigate("/member/memberlogin");
    //     } else if (step < 1) {
    //         navigate("/registration/plan");
    //     }
    // }, [authorized, step, navigate]);

    useEffect(() => {
        const fetchMemberData = async () => {
            try {
                if (mem_id) {
                    const response = await axios.get(`${backend}member/memareaData/${mem_id}`);
                    // console.log("Response data:", response.data);
                    
                    if (response.data && response.data.length > 0) {
                        const memberData = response.data[0];  // 確保這是數組且有內容
                        setFormData({
                            name: memberData.chinese_name || "",
                            fname: memberData.first_name || "",
                            lname: memberData.last_name || "",
                            email: memberData.email || "",
                            phone: memberData.phone_num || "",
                            school: memberData.school || "",
                            address: memberData.address || "",
                            status: memberData.status || "",
                            idIdentity: memberData.id_num || "",
                            tax_num: memberData.tax_num || "",
                            company: memberData.company || "",
                            deliver: memberData.deliver || [],
                            course: Array.isArray(memberData.course)
                                        ? memberData.course
                                        : typeof memberData.course === 'string'
                                        ? memberData.course.split(',').map(s => s.trim()).filter(Boolean)
                                        : [],
                            book: Array.isArray(memberData.book)
                                        ? memberData.book
                                        : typeof memberData.book === 'string'
                                        ? memberData.book.split(',').map(s => s.trim()).filter(Boolean)
                                        : [],
                            info_way: memberData.info_way || [],
                        });
                    } else {
                        console.error("No member data found");
                    }
                }
            } catch (error) {
                console.error("Failed to fetch member data", error);
            }
        };
        fetchMemberData();
    }, [mem_id]);

    
    const handleCourseSelection = (e) => {
        const { value, checked } = e.target;
    
        setFormData((prevFormData) => {
            const updatedCourse = checked 
                ? Array.from(new Set([...prevFormData.course, value]))
                : prevFormData.course.filter(course => course !== value);
    
            return { ...prevFormData, course: updatedCourse };
        });
    };

    const handleBookChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prevData) => {
            const updatedBook = checked
                ? [...prevData.book, value]
                : prevData.book.filter((book) => book !== value);
    
            return {
                ...prevData,
                book: updatedBook,
            };
        });
    };

    const handleinfoChange = (e) => {
        const { value, checked } = e.target;
    
        setFormData((prevFormData) => {
            const updatedInfo = checked 
                ? [...(prevFormData.info_way || []), value] 
                : prevFormData.info_way.filter(info => info !== value);
    
            return { ...prevFormData, info_way: updatedInfo };
        });
    };
    const validateTWID = (id) => {
        const letters = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
        const regex = /^[A-Z][12]\d{8}$/;

        if (!regex.test(id)) {
            return false; // 格式不符合
        }

        const firstLetter = id.charAt(0);
        const index = letters.indexOf(firstLetter) + 10;
        const n1 = Math.floor(index / 10);
        const n2 = index % 10;

        const numbers = [n1, n2, ...id.substr(1).split('').map(Number)];
        const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
        let sum = 0;

        for (let i = 0; i < numbers.length; i++) {
            sum += numbers[i] * weights[i];
        }

        return sum % 10 === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        let formValid = true;
        const newErrors = {};
    
        // 中文姓名正則：至少 2 個中文字
        const chineseNameRegex = /^[\u4e00-\u9fa5]{2,}$/;
    
        // 英文姓名正則
        const englishNameRegex = /^[a-zA-Z\s\-]+$/;
    
        // 信箱
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        // 手機
        const phoneRegex = /^(\+?886\-?|0)?9\d{8}$/;
    
        // 必填欄位統一檢查
        const requiredFields = ["name", "fname", "lname", "email", "phone", "idIdentity", "school", "status", "deliver"];
        requiredFields.forEach((field) => {
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                newErrors[field] = "此欄位是必填欄位";
                formValid = false;
            }
        });
    
        // 若選擇了快遞，course 也需必填
        if (formData.deliver.includes("快遞") && (!formData.course || formData.course.length === 0)) {
            newErrors.course = "請選擇快遞科目";
            formValid = false;
        }
    
        // 個別欄位格式驗證
        if (formData.name && !chineseNameRegex.test(formData.name.trim())) {
            newErrors.name = "請輸入 2 個以上的中文姓名";
            formValid = false;
        }
    
        if (formData.fname && !englishNameRegex.test(formData.fname.trim())) {
            newErrors.fname = "First name 請輸入英文";
            formValid = false;
        }
    
        if (formData.lname && !englishNameRegex.test(formData.lname.trim())) {
            newErrors.lname = "Last name 請輸入英文";
            formValid = false;
        }
    
        if (formData.email && !emailRegex.test(formData.email.trim())) {
            newErrors.email = "請輸入正確的信箱";
            formValid = false;
        }
    
        if (formData.phone && !phoneRegex.test(formData.phone.trim())) {
            newErrors.phone = "請輸入正確的手機號碼";
            formValid = false;
        }
    
        if (formData.idIdentity && !validateTWID(formData.idIdentity.trim())) {
            newErrors.idIdentity = "請輸入正確的身分證號碼";
            formValid = false;
        }
    
        setErrors(newErrors); // 確保錯誤狀態更新
        // console.log("Updated errors:", newErrors); // 調試
        
    
        if (formValid) {
            localStorage.setItem("formData", JSON.stringify(formData));
    
            const payload = {
                ...formData,
                mem_id,
                course: Array.isArray(formData.course)
                ? formData.course
                    .filter(c => typeof c === 'string' && c.trim() !== "" && c !== "FAR" && c !== "REG" && c !== "AUD" && c !== "ISC" && c !== "BAR")
                    .join(",")
                : "",
                book: Array.isArray(formData.book)
                    ? formData.book.filter(Boolean).join(",")
                    : "",
                info_way: Array.isArray(formData.info_way)
                    ? formData.info_way.filter(Boolean).join(",")
                    : "",
            };
    
            // console.log("Payload before sending:", payload);
            
            try {
                const response = await axios.post(`${backend}member/payinfo`, payload, {
                    headers: { "Content-Type": "application/json" },
                });
                // console.log("更新成功：", response.data);
                setStep(3);
                window.location.href = "./pay";
            } catch (error) {
                console.error("更新會員資料失敗：", error.response?.data || error.message);
            }
        } else {
            // console.log("表單有錯誤");
        }
    };
    
    return (
        <>
            <div className="container mb100 mt100">
                <div className="beckertitlename mt100 mb-5">請填購買資料</div>
                <div className="card w-75 p-5 m-auto">
                    <div className="card-body">
                        <form>
                            <div className="form-group mb-4">
                                <label htmlFor="name" className="mb-2">*中文全名</label>
                                <input
                                    className={`form-control ${errors.name && "is-invalid"}`}
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>

                            <div className="form-group mb-4">
                                <label className="mb-2">*英文拼音全名</label><br />
                                <div className="row">
                                    <div className="col">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.fname && "is-invalid"}`}
                                            placeholder="First name"
                                            value={formData.fname}
                                            onChange={(e) => setFormData({ ...formData, fname: e.target.value })}
                                        />
                                        {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                                    </div>
                                    <div className="col">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.lname && "is-invalid"}`}
                                            placeholder="Last name"
                                            value={formData.lname}
                                            onChange={(e) => setFormData({ ...formData, lname: e.target.value })}
                                        />
                                        {errors.lname && <div className="invalid-feedback">{errors.lname}</div>}
                                    </div>
                                </div>
                                <small id="enameHelp" className="form-text text-muted">同護照上顯示之英文名，例：Da-Ming, Wang</small>
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="phone" className="mb-2">*聯絡電話</label>
                                <input
                                    type="tel"
                                    className={`form-control ${errors.phone && "is-invalid"}`}
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                />
                                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="email" className="mb-2">*電子郵件</label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email && "is-invalid"}`}
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                <small id="emailHelp" className="form-text text-muted">
                                    將依此註冊您的 Becker 教材帳號。若您曾經購買或試用過任何 Becker 產品，請提供「尚未用來註冊過 Becker」的電子郵件住址
                                </small>
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="idIdentity" className="mb-2">*身分證字號</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.idIdentity && "is-invalid"}`}
                                    id="idIdentity"
                                    name="idIdentity"
                                    value={formData.idIdentity}
                                    onChange={(e) => setFormData({ ...formData, idIdentity: e.target.value })}
                                />
                                {errors.idIdentity && <div className="invalid-feedback">{errors.idIdentity}</div>}
                                <small id="idHelp" className="form-text text-muted">將依此註冊您的中文「雲端導讀與解題」觀看帳號</small>
                            </div>

                            <div className="form-group mb-4">
                                <label htmlFor="school" className="mb-2">*所屬(或畢業)學校與科系</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.school && "is-invalid"}`}
                                    id="school"
                                    value={formData.school}
                                    onChange={(e) => setFormData({ ...formData, school: e.target.value })}
                                />
                                {errors.school && <div className="invalid-feedback">{errors.school}</div>}
                            </div>

                            <div className="form-group mb-4">
                                <label className="mb-2">*目前職業</label>
                                <select
                                    className={`form-control ${errors.status && "is-invalid"}`}
                                    value={formData.status}
                                    onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                >
                                    <option value="" disabled>請選擇職業</option>
                                    <option value="incumbent">在職者</option>
                                    <option value="student">在學生</option>
                                    <option value="candidates">全職考生</option>
                                    <option value="unemployed">待業中</option>
                                </select>
                                {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                            </div>

                            <div className={`form-group mb-4 ${errors.deliver ? "is-invalid" : ""}`}>
                                <label className="mb-2">*是否需快遞寄送紙本教科書？</label>
                                <div className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        id="book1"
                                        name="deliverOption"
                                        className="custom-control-input"
                                        onChange={() => {
                                            setFormData({ ...formData, deliver: ["快遞"] });
                                            setShowCourses(true);
                                        }}
                                    />
                                    <label className="custom-control-label" htmlFor="book1">是</label>
                                </div>
                                <div className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        id="book2"
                                        name="deliverOption"
                                        className="custom-control-input"
                                        onChange={() => {
                                            setFormData({ ...formData, deliver: ["自取"] });
                                            setShowCourses(false);
                                        }}
                                    />
                                    <label className="custom-control-label" htmlFor="book2">否</label>
                                </div>
                                <small id="bookHelp" className="form-text text-muted">
                                    快遞計費方式：單箱最多可裝 2 科書籍，每箱快遞費 TWD 100 元。
                                </small>
                                {errors.deliver && <div className="invalid-feedback">{errors.deliver}</div>}
                            </div>
                            {showCourses && (
                            <div className={`form-group mb-4 ${errors.course ? "is-invalid" : ""}`}>
                                <label className="mb-2">（承上題）選擇「是，需要快遞寄送」者，近期欲領取 (快遞收取) 哪些科目？請註明。</label>
                                <div className="custom-control custom-checkbox mb-2">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="aud"
                                        value="AUD"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="aud">AUD</label>

                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="far"
                                        value="FAR"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="far">FAR</label>

                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="reg"
                                        value="REG"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="reg">REG</label>

                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="isc"
                                        value="ISC"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="isc">ISC</label>

                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="tcp"
                                        value="TCP"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="tcp">TCP</label>

                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="bar"
                                        value="BAR"
                                        onChange={handleBookChange}
                                    />
                                    <label className="custom-control-label m-2" htmlFor="bar">BAR</label>
                                </div>
                            </div>
                        )}
                            <div className={`form-group mb-4 ${errors.address ? "is-invalid" : ""}`}>
                                <label htmlFor="address" className="mb-2">發票/紙本教科書郵寄地址</label>
                                <Address
                                    onAddressChange={(combinedAddress) => setFormData({ ...formData, address: combinedAddress })}
                                />
                                {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                            </div>
                            <div className="form-group mb-4">
                                <label  className="mb-2">發票開立統一編號與抬頭</label>
                                <input type="text" className="form-control mb-2" id="tax_num" placeholder="統一編號" onChange={(e) => setFormData({ ...formData, tax_num: e.target.value })}/>
                                <input type="text" className="form-control" id="company" placeholder="公司抬頭" onChange={(e) => setFormData({ ...formData, company: e.target.value })}/>
                                <small id="invoiceHelp" className="form-text text-muted">留白則為一般二聯式發票</small>
                            </div>
                            <div className="form-group mb-4">
                                <label  className="mb-2">選擇「專業/全修/選修」方案者，欲參加中文課的方式：</label><br/>
                                <small id="invoiceHelp" className="form-text text-muted">依照個人需求，可複選。</small>
                                <div className="custom-control custom-checkbox mb-2">
                                    <input type="checkbox" className="custom-control-input" id="onside" value="onside" onChange={handleCourseSelection}/>
                                    <label className="custom-control-label m-2" for="onside">現場面授</label>
                                    
                                    <input type="checkbox" className="custom-control-input" id="online" value="online" onChange={handleCourseSelection}/>
                                    <label className="custom-control-label m-2" for="online">雲端教室 (線上看課)</label>
                                </div>
                            </div>
                            <label  className="mb-2">您是從何處得知 Becker Taiwan (捷進)</label>
                            <div className="custom-control custom-checkbox mb-2">
                                <input type="checkbox" className="custom-control-input" id="google" value="google" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="google">Google</label>
                                
                                <input type="checkbox" className="custom-control-input" id="facebook" value="facebook" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="facebook">Facebook</label>
                                
                                <input type="checkbox" className="custom-control-input" id="instagram" value="instagram" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="instagram">Instagram</label>
                                
                                <input type="checkbox" className="custom-control-input" id="line" value="line" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="line">LINE</label>
                                
                                <input type="checkbox" className="custom-control-input" id="edm" value="edm" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="edm">EDM</label>
                                
                                <input type="checkbox" className="custom-control-input" id="friend" value="friend" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="friend">親友同事介紹</label>
                                
                                <input type="checkbox" className="custom-control-input" id="lecture" value="lecture" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="lecture">校園講座</label>
                                
                                <input type="checkbox" className="custom-control-input" id="accounting" value="accounting" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="accounting">事務所內部宣傳</label>
                                
                                <input type="checkbox" className="custom-control-input" id="mrt" value="mrt" onChange={handleinfoChange}/>
                                <label className="custom-control-label m-2" for="mrt">捷運廣告</label>
                                
                            </div>
                            <button type="submit" className="btn btn-primary" onClick={handleSubmit}>送出</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Payinfo;